/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { EnumDictionary } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent } from '@gh/core-ui';
import { SalespersonSelectItem } from '../../../resources/hlp.model';
import { HlpDetailsBusinessService } from '../../../resources/hlp-details-business.service';
import { map$ } from '@gh/rx/operators';
import { ListingStatus } from '@gh/builder-shared-data';

@Component({
  selector: 'gh-hlp-details-common',
  template: require('./hlp-details-common-tab.component.html'),
  styles: [require('./hlp-details-common-tab.component.scss')],
})
export class HlpDetailsCommonTabComponent {
  @Input() listingStatuses: EnumDictionary<ListingStatus>;

  constructor(
    public businessService: HlpDetailsBusinessService,
    ) {
  }

  loadSalesPersons(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.findSalesPersonsByName(event.query, {
      showInactive: false,
    }).pipe(map$((salesPersons) => {
      const control = this.businessService.mainForm.get('commonDetails.alternateSalesperson');
      return control.value ? salesPersons.filter(
      (item) => item.id !== this.businessService.mainForm.get('commonDetails.alternateSalesperson')?.value.id,
    ) : salesPersons;
    })));
  }

  loadAlternateSalesPersons(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.findSalesPersonsByName(event.query, {
      showInactive: false,
    }).pipe(map$((salesPersons) => {
      const control = this.businessService.mainForm.get('commonDetails.salesperson');
      return control.value ? salesPersons.filter((item) =>
            item.id !== this.businessService.mainForm.get('commonDetails.salesperson')?.value.id) : salesPersons;
    })));
  }

  onPrimarySalesPersonSelected(salesPerson: SalespersonSelectItem): void {
    if (!salesPerson) {
       this.businessService.mainForm.get('commonDetails.salesperson').setValue(undefined);
    }
  }

  onAlternateSalesPersonSelected(salesPerson: SalespersonSelectItem): void {
    if (!salesPerson) {
      this.businessService.mainForm.get('commonDetails.alternateSalesperson').setValue(undefined);
    }
  }

}
